import { put, takeLatest, all, call } from 'redux-saga/effects';
import api from '../../api/api';

import { getAlertsFailure, getAlertsSuccess } from './alertsAction';
import { GET_ALERTS_REQUEST } from './alertsActionTypes';
import { GlobalAlerts } from './types';

export function* getAlertsRequest(action: any): any {
  try {
    const alertsData = yield call(api.alerts.getAlerts);
    const sortedData =
      alertsData?.data.sort((prev: GlobalAlerts, current: GlobalAlerts) => {
        if (new Date(prev.startTime ?? 0).getTime() > new Date(current.startTime ?? 0).getTime()) {
          return 1;
        }
        return -1;
      }) ?? [];
    yield put(getAlertsSuccess(sortedData));
  } catch (error) {
    //@ts-ignore
    yield put(getAlertsFailure(error.response.data.message));
  }
}

export default function* rootSaga() {
  yield all([takeLatest(GET_ALERTS_REQUEST, getAlertsRequest)]);
}
